import React from 'react';
import Utilities from '@util/Utilities';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import AlertExecution from '@app/model/alert/AlertExecution';
import ParityPriceComparisonAlertExecutionNotificationOutput
	from '@app/model/alert/output/ParityPriceComparisonAlertExecutionNotificationOutput';

type Props = {
	companyHotel: CompanyHotel;
	alertExecution: AlertExecution;
	notificationOutput: ParityPriceComparisonAlertExecutionNotificationOutput;
	isInDrawer?: boolean;
};


const ParityPriceComparisonNotificationRowFragment: React.FC<Props> = ({
	notificationOutput,
	isInDrawer = false,
}) => {
	const { current } = notificationOutput;
	const providerStats = [...current.providerStats]
		.sort((a, b) => Math.abs(b.percentage) - Math.abs(a.percentage));

	return <article className={`${isInDrawer ? 'bg-gray-50' : 'bg-white'} overflow-hidden rounded-xl border border-gray-200 shadow-sm`}>
		<div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
			<h3 className="text-sm font-semibold text-gray-950">{Utilities.formatDateString(current.statDate, 'DD MMM YYYY', false)}</h3>
			<p className="text-sm text-gray-500">Your Price: <span className="font-semibold text-gray-950">{Utilities.formatPrice(current.brandPrice)}</span></p>
		</div>
		<div className="divide-y divide-gray-100 px-6 py-2">
			{providerStats.map(providerStat => <div key={providerStat.provider} className="grid grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-3 py-3 text-sm">
				<div className="font-semibold text-gray-950">
					{providerStat.isOta && providerStat.iconUrl && <img
						className="mr-2 inline-block h-4 w-4 align-text-bottom"
						alt={providerStat.provider}
						title={providerStat.provider}
						src={`https://${providerStat.iconUrl}`}
					/>}
					<span>{providerStat.provider}</span>
				</div>
				<FormatDifferencePercentage percentage={providerStat.percentage} />
				<span className="text-gray-600">{Utilities.formatPrice(providerStat.price)}</span>
			</div>)}
		</div>
	</article>;
};

const FormatDifferencePercentage: React.FunctionComponent<{ percentage: number }> = ({ percentage }) => {
	const rounded = parseInt(Utilities.formatDouble(percentage, 0));
	return rounded > 0
		? <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-semibold text-green-700 ring-1 ring-inset ring-green-600/10">+{rounded}%</span>
		: <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-semibold text-red-700 ring-1 ring-inset ring-red-600/10">{rounded}%</span>;
};

export default ParityPriceComparisonNotificationRowFragment;
